import React from 'react';
import {saveTopic} from './SenseAction';
import Dict from 'dict-lib';
import {Typeahead} from 'react-bootstrap-typeahead';
import {Button, Row, Grid} from 'react-bootstrap';
import {LexemeUtilities} from './../../../page/editor/LexemeHelper';
import './../../../../lexeme/page/parts/03_Subentries/parts/LexemeSenses.css';
import './../../../../_css/lexeme.css';
import stylesLexemeSenses from './../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css';
import ReactDom from "react-dom";
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";
import {SCRadiobutton} from "../../../../dict-components/radiobutton/SCRadiobutton";
import stylesSearchMenu from "../../../../_css/dictionary/searchMenu.module.css";
import {userService} from "../../../../_redux/authentication/services/user.services";
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";


export class SenseTopics extends React.Component {

    constructor(props) {
        super(props);

        this.isGlossary = AdministrationUtilities.isGlossary();
        this.isLoggedGlossary = userService.isLogged() && this.isGlossary;
        this.topics =  this.isGlossary ? AdministrationUtilities.getTopics() : null;
        this.isLoggedGlossaryWithUserTopics = this.isLoggedGlossary && this.topics !== null;
        this.defaultTopicValue = this.isLoggedGlossaryWithUserTopics ? {id: userService.getDefaultTopic()} : typeof this.props.item.topic !== 'undefined' && Object.keys(this.props.item.topic).length > 0 ? {id: this.props.item.topic.id} : {id: ''};
        this.topic = typeof this.props.item.topic !== 'undefined' && this.props.item.topic !== null ? {id: this.props.item.topic.id} : this.defaultTopicValue;

        this.state = {
            item: this.props.item,
            topics: [],
            topic: this.topic
        };

        this._handleSetTopics = this._handleSetTopics.bind(this);
    }

    componentWillMount() {
        //if (this.isLoggedGlossaryWithUserTopics) {
            const topics = AdministrationUtilities.getTopics();
            this.setState({topics});
       /* } else {
            Dict.call(service).then(result => {
                this.setState(result);
            });
        }*/
    }

    componentDidMount() {
        /*if (!this.isLoggedGlossaryWithUserTopics)
            this.refs.refTopics.getInstance().focus();*/
    }

    _saveTopic() {
        this.setState({btDisabled: true});
        saveTopic(this.state.item.ids, this.state.topic.id).then(result => {
            this.setState({btSaveState: "success", btDisabled: false}, function () {
                setTimeout(function () {
                    this.setState({btSaveState: "primary"});
                }.bind(this), 1000);
            });
        });
    }

    _handleSetTopics(item) {
        var topic = item.length > 0 ? {id: item[0].id, label: item.label} : {id: '', label: ''};
        this.setState({topic});
    }

    _retrieveChooseElement() {
        if (this.isLoggedGlossaryWithUserTopics && false) {
            return <SCRadiobutton key={"key-radio-insert-topic"} id="dic-insert-topic"
                                  label={''}
                                  additionalClass={stylesSearchMenu['insert-glossary-radio']}
                                  items={this.topics.map((item) => {
                                      return {label: item.label, code: item.id + ''};
                                  })}
                                  default={userService.getDefaultTopic()}
                                  callbackParent={(topic) => {
                                      this.setState({topic});
                                  }}/>;
        } else {
            var selectTopic = typeof this.state.topic === 'undefined' || this.state.topic.length === 0 ? "" : LexemeUtilities.getTypeaheadItem(this.state.topics, this.state.topic);

            const itemTopic = typeof this.props.item.topic !== 'undefined' ? this.props.item.topic.extendedUniqueDescription : '---'

            return <Typeahead
                clearButton
                ref={"refTopics"}
                minLength={0}
                align={"justify"}
                onChange={item => this._handleSetTopics(item)}
                options={this.state.topics}
                placeholder={Dict.t('TOPICS') + " [" + itemTopic + "]"}
                selected={selectTopic}
            />;
        }

    }


    render() {
        return <Grid fluid>
            <Row>{this._retrieveChooseElement()}
            </Row>
            <Row className={stylesLexemeSenses['row-bt-sense-topics']}>
                <SCSubmitButton onClick={() => this._saveTopic()} text={Dict.t('SAVE')}/>
            </Row>
        </Grid>;
    }


}
